import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { FilterParams } from 'src/app/common-interfaces-classes/FilterParams';

@Injectable({
  providedIn: 'root',
})
export class FilterMapperService {
  constructor(private router: Router) {}
  mapProjectResponse(response): Partial<FilterParams> {
    const data = response;
    console.log('data', data);
    const mergedJobtitles = data?.jobtitles?.map(j=>this.prepareFilterChipData(j)).concat(data?.excluded_jobtitles?.map(j => this.prepareFilterChipData(j, false,true))) ?? [];
    const mergedCompanies = data?.companies?.map(c=>this.prepareFilterChipData(c)).concat(data?.excluded_companies?.map(c => this.prepareFilterChipData(c, false,true))) ?? [];
    const mergedskills = data?.preferredskills?.map(s=>this.prepareFilterChipData(s)).concat(data?.mandatoryskills?.map(s => this.prepareFilterChipData(s, true))).concat(data?.excluded_preferredskills?.map(s => this.prepareFilterChipData(s, false,true))).concat(data?.excluded_mandatoryskills?.map(s=>this.prepareFilterChipData(s, true, true))) ?? [];
    const mergedIndustries = data?.industries?.map(i=>this.prepareFilterChipData(i)).concat(data?.excluded_industries?.map(i=>this.prepareFilterChipData(i, false, true))) ?? [];
    const pastjobtitle = data?.pastjobtitles?.map(p=>this.prepareFilterChipData(p)).concat(data?.excluded_pastjobtitles?.map(p=>this.prepareFilterChipData(p, false, true))) ?? [];
    const mergedfunctions = data?.functions?.map(f=>this.prepareFilterChipData(f)).concat(data?.excluded_functions?.map(p=>this.prepareFilterChipData(p, false, true))) ?? [];
    const mergedlocations = data?.locations?.map(l=>this.prepareFilterChipData(l)).concat(data?.excluded_locations?.map(l=>this.prepareFilterChipData(l, false, true))) ?? [];

    return {
      jobTitleSelectedList: mergedJobtitles,
      companySelectedList: mergedCompanies,
      skillsSelectedList: mergedskills,
      industrySelectedList: mergedIndustries,
      locationSelectedList: mergedlocations,
      yearsofexperienceFrom: data.minexperience ?? null,
      yearsofexperienceTo: data.maxexperience ?? null,
      seniority: data.seniority ?? [],
      jobTitleStatus: data?.jobtitletype ?? "Current",
      companyStatus: data?.companytype ?? "Current",
      industryStatus: data?.industrytype ?? "Current",
      fromgraduationyear: data?.fromgraduationyear ?? null,
      tograduationyear: data?.tograduationyear ?? null,
      gender: data?.genders?.length ? data?.genders[0]: 'All',
      pastJobTitleSelectedList: pastjobtitle ?? [],
      currentfromyearsofexperience: data?.current_minexperience ?? null,
      currenttoyearsofexperience: data?.current_maxexperience ?? null,
      companysize: data?.companysize ?? [],
      functionSelectedList: mergedfunctions ?? [],
      distancefromselectedlocations: data?.distance ? data?.distance: 100,
      distancefromselectedlocationsmeasurementunit: data?.distanceunit ? data?.distanceunit == 'km' ?'kilometers' : 'miles' : 'kilometers',
      educationSelectedList: data?.educationaldegrees ? data?.educationaldegrees?.map(f=>this.prepareFilterChipData(f)): [],
      schoolSelectedList: data?.schools ? data?.schools?.map(s=>this.prepareFilterChipData(s)): [],
      fieldOfStudySelectedList: data?.educationalmajors ? data?.educationalmajors?.map(e=>this.prepareFilterChipData(e)): [],
      schoolLocationSelectedList: data?.schoollocation ? data?.schoollocation?.map(s=>this.prepareFilterChipData(s)): [],
      yearsofexperience: data?.experiencetype ?? 'Current',
      profilehighlights: data?.profilehighlights ?? [],
positionhierarchy: data?.positionhierarchies ?? [],
locationcontinents : data?.locations_meta_data?.map(x=>{

  return{
     key: x?.value,
  continent: x?.location_continent
  }
}),
continentstobeincluded: data?.continentstobeincluded?.length ? data.continentstobeincluded: data?.locations_meta_data?.length ? data?.locations_meta_data.map(x=>x.location_continent): [],
location_type: data?.locations_meta_data?.length ? data?.locations_meta_data.map(x=>x.location_type): [],
fullNameSelectedList: data?.fullnames ? data?.fullnames?.map(f=>this.prepareFilterChipData(f)): [],
booleanquery: data?.booleanquery ?? '*',

    };
  }

      /**
       * prepare Filter chip data for person suggestions
       */
      prepareFilterChipData(value: string, ismandatory: boolean = false, isExcluded: boolean = false): any {
        return {
          key: value,
          isExcluded: isExcluded,
          isMandatory: ismandatory,
          chipkey: value.replace('.searchastext', '').replace('.aisearch', '').replace('.includedaisearch', ''),
          isSuggested: value.includes('.aisearch') || value.includes('.includedaisearch'),
        }
      }


isHirePieplineListing() {
    const url = this.router.url;
    return (url?.includes("pipeline"));
}

isHireTalentInsights() {
  const url = this.router.url;
  return (url?.includes('talent-insights'))
}

isHireMyCandidatesListing() {
  const url = this.router.url;
  return(url?.includes('my-candidate'));
}
}
